import BlockFormatNormalizationsPluginFactory from '../Blocks/BlockFormatNormalizationsPluginFactory';

const QuoteNormalizationsPlugin =
  BlockFormatNormalizationsPluginFactory('quote');

export default QuoteNormalizationsPlugin;
